module.exports = __webpack_public_path__ + "static/media/notes.9ce3d284.svg";